import { h, Fragment } from "preact";

import CardTemplate from "../Common/CardTemplate";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import UpdateIcon from '@mui/icons-material/Update';

import {
    Box,
    Button,

    Stack,
    Typography,
} from "@mui/material";


export default function ProspectMeetingsCard({ mtngs, app }) {

    return (
        <CardTemplate
            title={<Typography variant="h5">Mes rendez-vous</Typography>}
            buttons={
                false && (!dl.oabs || !(dl.oabs && (dl.bid_p === null || (dl.bid_p !== null && !dl.bid_p.a)))) ? (<ButtonWithTooltipAndBadge
                    tooltip="Mes rendez-vous"
                    icon={<MoreTimeIcon />}
                    onclick_cb={() => {
                        app.refPopUp.current.handleChangeState(
                            {
                                opened: true,
                                type: "038",
                                params: {
                                    id: dl.u,
                                    actualDeal: dl,
                                    internal: true
                                }
                            })
                    }} />) : null}
            badge={false}

            content={
                <Stack >
                    {mtngs && mtngs.length == 0 && <em>Pas de rendez-vous</em>}
                    {mtngs && mtngs.map((mtg) => {
                        return <Box display={"flex"} justifyContent="flex-between" alignItems={"center"} style="width: 100%;">
                            <Box p={1}>
                                <Typography>{mtg.lbl}</Typography>
                                <Typography variant="caption">{mtg.adr} {mtg.adr2}</Typography>
                            </Box>
                            <Box p={1}>
                                <Button
                                    variant="outlined"
                                    onClick={() => app.refPopUp.current.handleChangeState(
                                        {
                                            opened: true, type: "039", params: {
                                                mtg: mtg
                                            }
                                        })}
                                    startIcon={<UpdateIcon />}
                                >Modifier</Button>
                            </Box>
                        </Box>
                    })}
                </Stack >
            }
        />)

}

